export const brightCheckedClass = 'bright-checked';
export const checkImageBrightness = (img) => {
  // check img is same domain
  const fullUrl = new URL(img.src);

  if (!fullUrl.href.startsWith(window.location.origin)) {
    return '';
  }

  if (!img.width || !img.height) {
    return 'dark';
  }

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.width = img.width;
  canvas.height = img.height;
  ctx.drawImage(img, 0, 0, img.width, img.height);

  const imageData = ctx.getImageData(0, 0, img.width, img.height);
  const { data } = imageData;

  let r; let g; let b; let avg;
  let colorSum = 0;

  // Calculate the average brightness of an image
  for (let i = 0; i < data.length; i += 4) {
    // Red
    r = data[i];
    // Green
    g = data[i + 1];
    // Blue
    b = data[i + 2];

    // The average value of the RGB color
    avg = Math.floor((r + g + b) / 3);
    colorSum += avg;
  }

  // Calculate the average brightness of an image
  const brightness = Math.floor(colorSum / (img.width * img.height));
  // Return the brightness of the image
  return brightness > 128 ? 'light' : 'dark';
};

export default class ColorSelection {
  constructor(el) {
    this.$el = $(el);
    this.dom = {
      $colorRadio: this.$el.find('.js-color-radio'),
      $colorName: this.$el.find('.js-color-name'),
      $colorBg: this.$el.find('.js-color-bg'),
    };
    this.elementClasses = {
      priceWrap: '.js-price-wrap',
      productPrice: '.js-product-price',
    };

    this.classes = {
      brightChecked: 'bright-checked',
    };

    this.init();
  }

  init() {
    this.checkColorImageBrightnessOnload();
    this.checkColorImageBrightness();
    // active first color radio when init
    this.dom.$colorRadio.eq(0).prop('checked', true);
  }

  changeColorEvent(callback) {
    this.dom.$colorRadio.on('change', (ev) => {
      const $target = $(ev.currentTarget);
      const colorName = $target.data('color');
      const price = $target.data('price');

      this.dom.$colorName.text(colorName);
      $target.closest(this.elementClasses.priceWrap).find(this.elementClasses.productPrice).text(price);
      if (callback && typeof callback === 'function') {
        callback($target);
      }
    });
  }

  checkColorImageBrightness() {
    this.dom.$colorBg.each((_i, el) => {
      const $el = $(el);
      this.checkColorImageBrightnessFunction($el);
    });
  }

  checkColorImageBrightnessFunction($el) {
    const $colorImg = $el.find('img');
    const colorImgElm = $colorImg.get(0);
    if (!$el.hasClass(this.classes.brightChecked) && (!$colorImg.hasClass('lazy') && $colorImg.hasClass('b-loaded')) && colorImgElm) {
      $el.addClass(this.classes.brightChecked);
      const brightness = checkImageBrightness(colorImgElm);
      $el.addClass(brightness);
    }
  }

  checkColorImageBrightnessOnload() {
    this.dom.$colorBg.each((_i, el) => {
      const $el = $(el);

      const $colorImg = $el.find('img');
      const colorImgElm = $colorImg.get(0);
      if (colorImgElm) {
        colorImgElm.onload = () => {
          this.checkColorImageBrightnessFunction($el);
        };
        // if image load error, add class to element to stop checking brightness
        colorImgElm.onerror = () => {
          $el.addClass(this.classes.brightChecked).addClass('dark');
        };
      }
    });
  }
}

/*
  colorNameNode is the element that contains the color name. must be a child of parentNode and display: inline-block to get the correct width
*/
export const setPositionColorName = (parentNode, colorNode, colorNameNode) => {
  if (!parentNode || !colorNode || !colorNameNode) {
    return;
  }
  const $parentNode = $(parentNode);
  const $colorNode = $(colorNode);
  const $colorNameNode = $(colorNameNode);
  // x1 is the distance from the center of the color node to the left edge of the parent node
  const x1 = $colorNode.offset().left + $colorNode.outerWidth() / 2 - $parentNode.offset().left;
  // x2 is the distance from the center of the color node to the right edge of the parent node
  const x2 = $parentNode.outerWidth() - x1;
  // x3 is a half of the color name node width
  const x3 = $colorNameNode.outerWidth() / 2;

  // reset position
  $colorNameNode.css({ transform: '' });
  if (x1 > x3) {
    const translateX = x1 - x3 + Math.min(x2 - x3, 0);
    $colorNameNode.css({ transform: `translateX(${Math.max(translateX, 0)}px)` });
  }
};